import {ChangeDetectionStrategy, Component} from '@angular/core';
import {Router} from '@angular/router';

import {AppRoutes} from 'frontend/constants/routes';

/**
 * Primary app login page.
 * TODO(egorm): make this page as authorization page.
 */
@Component({
  selector: 'tap-login-page',
  templateUrl: './login.ng.html',
  styleUrl: './login.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoginPage {
  constructor(private readonly router: Router) {}

  signIn() {
    this.continue();
  }

  private continue() {
    this.router.navigate([AppRoutes.GPT.path]);
  }
}
